import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {AccountModel} from "../../models/account.model";
import {EnrollmentType, EnrollmentTypeStrMap} from "../../enums/enrollment-type.enum";

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private baseUrl = `${environment.apiUrl}/account`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<AccountModel[]> {
    return this.http.get<AccountModel[]>(`${this.baseUrl}`);
  }

  getById(id: number): Observable<AccountModel> {
    return this.http.get<AccountModel>(`${this.baseUrl}/${id}`);
  }

  getByPropertyId(id: number): Observable<AccountModel> {
    return this.http.get<AccountModel>(`${this.baseUrl}/rentalProperty/${id}`);
  }

  update(model: AccountModel): Observable<void> {
    switch (EnrollmentTypeStrMap.get(<string>model.type)) {
      case EnrollmentType.INDIVIDUAL_OWNER:
        return this.updateIndividualOwner(model);
      case EnrollmentType.PROPERTY_MANAGEMENT:
        return this.updatePropertyManagement(model);
      case EnrollmentType.INDIVIDUAL_BED:
        return this.updateIndividualBed(model);
      default:
        return new Observable<void>((observer) => {
          observer.error("Account type not supported.");
          observer.complete();
        })
    }
  }

  updateIndividualOwner(model: AccountModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/updateOwner`, model);
  }

  updatePropertyManagement(model: AccountModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/updateProperty`, model);
  }

  updateIndividualBed(model: AccountModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/individualBed`, model);
  }
}
